import { Component, inject, Input, OnInit, Output } from '@angular/core';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { AlertaService } from '../alerta/alerta.service';
import { iEntrada, iCatalogos, iAcuerdo } from '../entrada/entrada.interface';
import { EntradaService } from '../entrada/entrada.service';
import { LoadingService } from '../loading/loading.service';
import { UsuarioService } from '../usuario/usuario.service';
import { AcuerdoMrbService } from './acuerdo-mrb.service';
//import { AsyncPipe } from '@angular/common';
import { ReactiveFormsModule, FormsModule, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { Store, select } from '@ngrx/store';
import { AppState } from '../app.state';
import { selectCatalogos } from '../states/catalogos/selector';
import { selectEntrada } from '../states/entrada/selector';
import { selectAcuerdo } from '../states/acuerdo/selector';
import { firstValueFrom, map, Observable, Subject, Subscription } from 'rxjs';
import { Editor, NgxEditorModule, Toolbar, Validators as Validatorsngx  } from "ngx-editor";
import { cargaAcuerdo, cargaAcuerdoCampos } from '../states/acuerdo/actions';
import { ActivatedRoute } from '@angular/router';
import { toolbarEditor } from '../utils';
import { iUsuario } from '../usuario/usuario.interface';
import { selectUsuario } from '../states/usuario/selector';
import { LoggerService } from '../logger/logger.service';
import moment from 'moment';

@Component({
  selector: 'app-acuerdo-mrb',
  standalone: true,
  imports: [MatToolbarModule, MatButtonModule, MatIconModule, MatTabsModule, ReactiveFormsModule, MatInputModule, 
    MatFormFieldModule, FormsModule, MatRadioModule, MatDatepickerModule, MatSelectModule, MatAutocompleteModule,
    MatChipsModule, EditorModule, MatSlideToggleModule, NgxEditorModule],
  providers: [provideNativeDateAdapter(),  { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' }, {provide: MAT_DATE_LOCALE, useValue: 'es-MX'}],
  templateUrl: './acuerdo-mrb.component.html',
  styleUrl: './acuerdo-mrb.component.css'
})
export class AcuerdoMrbComponent {
  private active = inject(ActivatedRoute);
  private loadingService = inject(LoadingService);
  private entradaService = inject(EntradaService);
  private usuarioService = inject(UsuarioService);
  private alertaService = inject(AlertaService);
  private acuerdoMrbService = inject(AcuerdoMrbService);
  private formBuilder:FormBuilder = inject(FormBuilder);
  private idEntrada = this.active.snapshot.params['id'];
  private idTema = this.active.snapshot.params['tema'];
  private logSrvc = inject(LoggerService);
  private subscriptions = new Subscription();

  private readonly store: Store<AppState> = inject(Store);
  private readonly stateCatalogos: any = this.store.pipe(select(selectCatalogos));
  private readonly stateEntrada: any = this.store.pipe(select(selectEntrada));
  private readonly stateAcuerdo: any = this.store.pipe(select(selectAcuerdo));
  private readonly stateUsuario: any = this.store.pipe(select(selectUsuario));

  @Input() listenToFather!: Observable<boolean>;
  @Output() sendToFather: Subject<any> = new Subject();

  public oEntrada: iEntrada;
  public oAcuerdo: iAcuerdo;
  public oCatalogos: iCatalogos;
  public oUsuario: iUsuario;
  public formAcuerdo!: FormGroup;
  public formAcuerdoNuevo!: FormGroup;
  public deshabilitado: boolean = false;
  public catAcuerdos: any[] = [];
  public catTemas: any[] = [];
  public catTipoTema: any[] = [];
  public catUsuarios: any[] = [];
  public catCategoria: any[] = [];
  public catCategorizacion: any[] = [];
  public editor: Editor;
  public editor_alta: Editor;
  public toolbar: Toolbar = toolbarEditor;

  temasLectura: any[] = [];
  temasEscritura: any[] = [];
  usuarioTemas: any[] = [];
  switchDisabled:boolean = false;
  tipoFormAlta: string = "";
  today: Date = new Date();

  constructor() {
    this.loadingService.show();

    this.oEntrada = structuredClone(this.stateEntrada.state().entrada);
    this.oAcuerdo = structuredClone(this.stateAcuerdo.state().acuerdo);
    this.oCatalogos = structuredClone(this.stateCatalogos.state().catalogos);
    this.oUsuario = structuredClone(this.stateUsuario.state().usuario);
    this.catUsuarios = this.oCatalogos.catUsuarios;
    this.editor = new Editor();
    this.editor_alta = new Editor();

    this.oAcuerdo = this.fnValidaResponsablesTema(this.oAcuerdo);

    this.formAcuerdo = this.formBuilder.group({
      acuerdo: [this.oAcuerdo.id_forma_envio, [Validators.required]],
      tema: [this.oAcuerdo.id_tema, [Validators.required]],
      descripcion_tema: [this.oAcuerdo.descripcionTema_html, [Validators.required]],
      tipo_tema: [this.oAcuerdo.id_tipo_tema, [Validators.required]],
      confidencial: [this.oAcuerdo.banEsConfidencial, [Validators.required]],
      id_categorizacion: [this.oAcuerdo.id_categorizacion, [Validators.required]],
      id_categoria: [this.oAcuerdo.id_categoria, [Validators.required]],
      analista: [this.oAcuerdo.id_fb_resp_analista, [Validators.required]],
      supervisor: [this.oAcuerdo.id_fb_resp_supervisor, [Validators.required]],
      coordinador: [this.oAcuerdo.id_fb_resp_coordinador, [Validators.required]]
    });
    
    ///////////////////////////// ONCHANGE BUSINESS RULES //////////////////////////////
    this.formAcuerdo.get('acuerdo')?.valueChanges.subscribe(value => {
      this.businessRules('acuerdo', value);
    });
    this.formAcuerdo.get('tema')?.valueChanges.subscribe(value => {
      this.businessRules('tema', value);
    });
    this.formAcuerdo.get('confidencial')?.valueChanges.subscribe(value => {
      this.businessRules('confidencial', value);
    });
    this.formAcuerdo.get('descripcion_tema')?.valueChanges.subscribe(value => {
      this.businessRules('descripcion_tema', value);
    });
    ////////////////////////////////////////////////////////////////////////////////////
    this.subscriptions.add(
      this.usuarioService.getUsuario().subscribe((usuario:any) => {
        this.usuarioTemas = Object.keys(usuario.temas);

        //Desactivamos el switch de confidencial
        this.switchDisabled = (this.usuarioTemas.length == 1 && this.usuarioTemas.indexOf("-KcOsYIkmr2FHgi4ubym") == 0);
        
        //Obtener los permisos
        this.temasLectura = this.usuarioTemas.filter(item => (usuario.temas[item].permiso == 1 || usuario.temas[item].permiso == 3)?item:false);
        this.temasEscritura = this.usuarioTemas.filter(item => (usuario.temas[item].permiso == 2 || usuario.temas[item].permiso == 3)?item:false);
      })
    );

    if(this.idEntrada != 'add') {
      this.formAcuerdo.disable({emitEvent: false});
      this.deshabilitado = true;
    }

    this.loadingService.hide();
  }

  async ngOnInit() {
    this.loadingService.show();

    this.subscriptions.add(this.store.select(selectEntrada).subscribe((oEntrada) => {
      this.oEntrada = structuredClone(oEntrada);
    }));

    this.subscriptions.add(this.store.select(selectAcuerdo).subscribe((oAcuerdo) => {
      this.oAcuerdo = structuredClone(oAcuerdo);
    }));

    this.formAcuerdo.statusChanges.subscribe((status:any) => {
      if(status == 'VALID') {
        const formData = this.formAcuerdo.value;
        this.fnCargaForm(formData);
      }
      this.sendToFather.next({formAcuerdo: status});
    });

    this.subscriptions.add(this.listenToFather.subscribe((oData: any) => {
      if(oData.accion == 'disabled' && this.oAcuerdo.id_edo_tema != 3) {
        this.deshabilitado = oData.deshabilitado;
        if(oData.deshabilitado) {
          this.formAcuerdo.disable({emitEvent: false});
        } else {
          this.formAcuerdo.enable({emitEvent: false});
        }
        this.validacionFormulario();
      }
    }));

    //this.catCategoria = await firstValueFrom(this.acuerdoMrbService.getCategoria());
    //this.catTipoTema = await firstValueFrom(this.acuerdoMrbService.getCatalogo(this.acuerdoMrbService.cats.TIPO_TEMA));
    //this.catCategorizacion = await firstValueFrom(this.acuerdoMrbService.getCatalogo(this.acuerdoMrbService.cats.CATEGORIZACION));
    //const catResult: any = await firstValueFrom(this.acuerdoMrbService.getAcuerdos());
    //this.catAcuerdos = catResult.acuerdos;

    this.subscriptions.add(this.acuerdoMrbService.getCategoria().subscribe((catalogo: any) => {
      this.catCategoria = catalogo;
    }));
    this.subscriptions.add(this.acuerdoMrbService.getCatalogo(this.acuerdoMrbService.cats.TIPO_TEMA).subscribe((catalogo: any) => {
      this.catTipoTema = catalogo;
    }));
    this.subscriptions.add(this.acuerdoMrbService.getCatalogo(this.acuerdoMrbService.cats.CATEGORIZACION).subscribe((catalogo: any) => {
      this.catCategorizacion = catalogo;
    }));
    /*this.subscriptions.add(this.acuerdoMrbService.getResponsablesAll().subscribe((catalogo: any) => {
      this.catUsuarios = catalogo;
    }));*/

    this.subscriptions.add(
      this.acuerdoMrbService.getAcuerdos().subscribe(async (catResult:any) => {
        this.loadingService.hide();
        this.catAcuerdos = catResult.acuerdos;
        if(this.oAcuerdo.id_forma_envio && this.oAcuerdo.id_tema) {
          if(this.catAcuerdos.filter(item => item.idFE == this.oAcuerdo.id_forma_envio).length == 0)
            this.catAcuerdos.unshift({idFE: this.oAcuerdo.id_forma_envio, fechaAcuerdo: this.oAcuerdo.fechaAcuerdo});
          
          await this.fnChangeAcuerdo();
          this.fnChangeTema();
        }
      })
    );

    //this.fnChangeAcuerdo();
    this.sendToFather.next({accion: 'ACUERDO CARGADO'});
    //this.loadingService.hide();
  }

  validacionFormulario() {
    Promise.resolve().then( () => {
      const status = this.formAcuerdo.status;
      this.sendToFather.next({formAcuerdo: status});
    });
  }

  businessRules(type:string, value: any) {
    if(type == 'acuerdo') {
      this.fnResetForm();
      this.fnChangeAcuerdo();
    }

    if(type == 'tema') {
      this.fnChangeTema();
    }

    if(type == 'confidencial') {
      this.fnChangeConfidencial(value);
    }

    if(type == 'confidencial_alta') {
      this.fnChangeConfidencialAlta(value);
    }

    if(type == 'descripcion_tema') {
      const onlyText = value.replace(/<[^>]*>/g, '');
      if(onlyText.length == 0)
        this.formAcuerdo.get('descripcion_tema')?.setValue('', {emitEvent: false});
    }
  }

  fnAlta (tipo:string) {
    this.tipoFormAlta = tipo;

    const id_tipo_tema = (this.oEntrada.tipo == "-KlPwP1qdz37zYgvUvP3")? 1 :
                          (this.oEntrada.tipo == "-KlPwX06xcZawaVUJS0Y")? 2 :
                            (this.oEntrada.tipo == "-KlPwTF46JjQ-W2jy9zV")? 3 : ''

    const id_fb_resp_analista = this.oEntrada.analista;
    const id_fb_resp_supervisor = this.oEntrada.supervisor;
    const id_fb_resp_coordinador = this.oEntrada.coordinador;

    let acuerdo_required = tipo == 'acuerdo'?[Validators.required]:[];

    this.formAcuerdoNuevo = this.formBuilder.group({
      acuerdo: ['', acuerdo_required],
      tema: ['', [Validators.required]],
      descripcion_tema: ['', [Validators.required]],
      tipo_tema: [id_tipo_tema, [Validators.required]],
      confidencial: [false, [Validators.required]],
      id_categorizacion: ['', [Validators.required]],
      id_categoria: ['', [Validators.required]],
      analista: [id_fb_resp_analista, [Validators.required, this.validateAnalista.bind(this)]],
      supervisor: [id_fb_resp_supervisor, [Validators.required, this.validateSupervisor.bind(this)]],
      coordinador: [id_fb_resp_coordinador, [Validators.required, this.validateCoordinador.bind(this)]]
    });

    this.formAcuerdoNuevo.get('confidencial')?.valueChanges.subscribe(value => {
      this.businessRules('confidencial_alta', value);
    });
  }

  async fnChangeAcuerdo () {
    this.loadingService.show();
    
    const id_acuerdo = this.formAcuerdo.get("acuerdo")?.value;
    const result: any = await firstValueFrom(this.acuerdoMrbService.getTemas(id_acuerdo));
    /*if(result.error) {
      let message = (result.message.msg)? result.message.msg : result.msg;
      this.alertaService.open("Error 022", message);
    }*/
    //this.fnResetForm();
    this.catTemas = (result.error)?[]:result.temas;
    this.loadingService.hide();
  }

  fnChangeTema () {
    this.loadingService.show();
    
    const idTema: string = this.formAcuerdo.get("tema")?.value;
    let oTema: any = this.catTemas.filter(item => item.id === idTema)[0];  

    if(oTema != undefined) {
      oTema = this.fnValidaResponsablesTema(oTema);
      
      this.formAcuerdo.patchValue({
        descripcion_tema: oTema.descripcionTema_html,
        tipo_tema: oTema.tipoTema,
        confidencial: oTema.esConfidencial,
        id_categorizacion: oTema.categorizacion,
        id_categoria: oTema.id_categoria,
        analista: oTema.respAnalista,
        supervisor: oTema.respSupervisor,
        coordinador: oTema.respCoordinador
      });

      this.formAcuerdo.updateValueAndValidity();
      this.fnCargaTema(oTema);
    }
    
    this.fnValidaForm();
    this.fnCancelar();
    this.loadingService.hide();
  }

  fnChangeConfidencial (confidencial: boolean) {
    if(confidencial == false && this.temasLectura.indexOf("-KcOsYIkmr2FHgi4ubym") !== -1) {
      this.formAcuerdo.get('id_categorizacion')?.setValue('-KcOsYIkmr2FHgi4ubym');
      this.fnResponsablesOpciones(true, this.formAcuerdo);
    } else {
      this.formAcuerdo.get('id_categorizacion')?.setValue('');
      this.fnResponsablesOpciones(false, this.formAcuerdo);
    }
  }

  fnChangeConfidencialAlta (confidencial: boolean) {
    if(!confidencial && this.temasLectura.indexOf("-KcOsYIkmr2FHgi4ubym") !== -1) {
      this.formAcuerdoNuevo.get('id_categorizacion')?.setValue('-KcOsYIkmr2FHgi4ubym');
      this.fnResponsablesOpciones(true, this.formAcuerdoNuevo);
    } else {
      this.formAcuerdoNuevo.get('id_categorizacion')?.setValue('');
      this.fnResponsablesOpciones(false, this.formAcuerdoNuevo);
    }
  }

  fnResponsablesOpciones (obligatorio: boolean, formulario: any) {
    if(obligatorio) {
      formulario.get('analista')?.setValidators([Validators.required, this.validateAnalista.bind(this)]);
      formulario.get('supervisor')?.setValidators([Validators.required, this.validateSupervisor.bind(this)]);
    } else {
      formulario.get('analista')?.clearValidators();
      formulario.get('analista')?.setErrors(null);
      formulario.get('supervisor')?.clearValidators();
      formulario.get('supervisor')?.setErrors(null);
    }

    formulario.get('analista')?.updateValueAndValidity();
    formulario.get('supervisor')?.updateValueAndValidity();
  }

  fnDatosNotificar (tipo:string) {
    const oNuevo = this.formAcuerdoNuevo.value;
    const acuerdo = this.formAcuerdo.get('acuerdo')?.value;

    let fechaAcuerdo = "";
    if(oNuevo.acuerdo == '') {
      fechaAcuerdo = this.catAcuerdos.filter(item=> item.idFE == acuerdo)[0].fechaAcuerdo;
    } else {
      fechaAcuerdo = moment(oNuevo.acuerdo).format('YYYY-MM-DD');
    }

    if(tipo == 'acuerdo')
      return {
        "nombreUsuario": this.oUsuario.nombre,
        "fechaAcuerdo": fechaAcuerdo,
        "id_categorizacion": oNuevo.id_categorizacion,
        "notificacion": "nuevoAcuerdo"
      }

    return {
      "nombreUsuario": this.oUsuario.nombre,
      "fechaAcuerdo": fechaAcuerdo,
      "nombreTema": oNuevo.tema,
      "descripcionTema": oNuevo.descripcion_tema.replace(/<[^>]*>/g, ''),
      "nombreAnalista": (oNuevo.confidencial == false)?this.catUsuarios.filter(item => item.id == oNuevo.analista)[0].nombre:"",
      "nombreSupervisor": (oNuevo.confidencial == false)?this.catUsuarios.filter(item => item.id == oNuevo.supervisor)[0].nombre:"",
      "nombreCoordinador": this.catUsuarios.filter(item => item.id == oNuevo.coordinador)[0].nombre,
      "id_categorizacion": oNuevo.id_categorizacion,
      "notificacion": "nuevoTema"
    }
  }

  fnGuardarAcuerdo () {
    this.loadingService.show();
    //fnGetDescripcionHtmlAlta();
    const oNuevo = this.formAcuerdoNuevo.value;

    const data = {
      "tipoForma": 1,
      "fechaAcuerdo": moment(oNuevo.acuerdo).format('YYYY-MM-DD'),
      "banAgregarTema": true,
      "temas": [
        {
          "indiceTema": 1,
          "nombreTema": oNuevo.tema,
          "descripcionTema": oNuevo.descripcion_tema.replace(/<[^>]*>/g, ''),
          "descripcionTema_html": oNuevo.descripcion_tema,
          "tipoTema": oNuevo.tipo_tema,
          "esConfidencial": oNuevo.confidencial,
          "categorizacion": oNuevo.id_categorizacion,
          "id_categoria": oNuevo.id_categoria,
          "respAnalista": oNuevo.analista,
          "respSupervisor": oNuevo.supervisor,
          "respCoordinador": oNuevo.coordinador
        }
      ]
    };

    this.subscriptions.add(
      this.acuerdoMrbService.agregarAcuerdo(data).subscribe((result:any) => {
        if (result.error) {
          let message = (result.message.msg)? result.message.msg : result.msg;
          this.alertaService.open("Error 020", message);
        } else {

          //Notificacion
          firstValueFrom(this.acuerdoMrbService.notificar(this.fnDatosNotificar("acuerdo"))).then((result: any) => {
            if(result.error) { 
              this.logSrvc.addLog(result);
            }
          });
          firstValueFrom(this.acuerdoMrbService.notificar(this.fnDatosNotificar("tema"))).then((result: any) => {
            if(result.error) { 
              this.logSrvc.addLog(result);
            }
          });

          //Cargamos Acuerdo
          const acuerdo = result.idAcuerdo;
          const tema = result.idTema;

          this.formAcuerdo.get('acuerdo')?.setValue(acuerdo, { emitEvent: false });
          this.formAcuerdo.get('tema')?.setValue(tema, { emitEvent: false });

          this.subscriptions.add(this.acuerdoMrbService.getAcuerdos().subscribe((result:any) => { 
            this.catAcuerdos = result.acuerdos;
            this.subscriptions.add(this.acuerdoMrbService.getTemas(acuerdo).subscribe((result:any) => { 
              this.catTemas = result.temas; 
              this.fnChangeTema(); 
            }));
          }));

          this.alertaService.open("Éxito", result.msg);
          //scope.fnCancelar();
        }

        this.loadingService.hide();
      })
    );
  }

  fnGuardarTema () {
    this.loadingService.show()
    //fnGetDescripcionHtmlAlta();
    const oNuevo = this.formAcuerdoNuevo.value;
    const acuerdo = this.formAcuerdo.get('acuerdo')?.value;

    const data = {
      "id_acuerdo": acuerdo,
      "id_tema": undefined,
      "indice": (this.catTemas)? this.catTemas.length + 1 : 1,
      "nombreTema": oNuevo.tema,
      "descripcionTema": oNuevo.descripcion_tema.replace(/<[^>]*>/g, ''),
      "descripcionTema_html": oNuevo.descripcion_tema,
      "tipoTema": oNuevo.tipo_tema,
      "esConfidencial": oNuevo.confidencial,
      "categorizacion": oNuevo.id_categorizacion,
      "id_categoria" : oNuevo.id_categoria,
      "respAnalista": oNuevo.analista,
      "respSupervisor": oNuevo.supervisor,
      "respCoordinador": oNuevo.coordinador
    };

    this.subscriptions.add(
      this.acuerdoMrbService.agregarTema(data).subscribe((result:any) => {
        if (result.error) {
          this.alertaService.open("Error 021", result.msg);
        } else {
          //Notificacion
          firstValueFrom(this.acuerdoMrbService.notificar(this.fnDatosNotificar("tema"))).then((result: any) => {
            debugger;
            if(result.error) { 
              this.logSrvc.addLog(result);
            }
          });

          //Cargamos Acuerdo
          this.formAcuerdo.get('tema')?.setValue(result.idTema, { emitEvent: false });
          this.subscriptions.add(this.acuerdoMrbService.getTemas(acuerdo).subscribe((result: any) => { 
            this.catTemas = result.temas;
            this.fnChangeTema(); 
          }));
          this.alertaService.open("Éxito", result.msg);
        }
        this.loadingService.hide();
      })
    );
  }

  fnGuardarNuevo () {
    if(this.tipoFormAlta == 'acuerdo')
      this.fnGuardarAcuerdo();

    if(this.tipoFormAlta == 'tema')
      this.fnGuardarTema()
  }

  fnCancelar () {
    if(this.formAcuerdoNuevo)
      this.formAcuerdoNuevo.reset({
        "acuerdo": "",
        "tema": "",
        "descripcionTema": "",
        "tipoTema": "",
        "esConfidencial": false,
        "categorizacion": "",
        "id_categoria" : "",
        "respAnalista": "",
        "respSupervisor": "",
        "respCoordinador": ""
      });

    this.tipoFormAlta = "";
  }

  fnCategorizacion (condidencial:boolean, categoria:string) {
    let disabled: boolean = true;
    
    if(condidencial == false && categoria == '-KcOsYIkmr2FHgi4ubym')
      disabled = false;
    
    if(condidencial == true && categoria != '-KcOsYIkmr2FHgi4ubym')
      disabled = false;
    

    return disabled;
  }

  fnCargaForm (oTema: any) {
    let oAcuerdo = {  
      id_acuerdo:             oTema.acuerdo,
      id_tema:                oTema.tema,
      descripcionTema:        oTema.descripcion_tema,
      descripcionTema_html:   oTema.descripcion_tema,
      id_tipo_tema:           oTema.tipo_tema,
      banEsConfidencial:      oTema.confidencial,
      id_categorizacion:      oTema.id_categorizacion,
      id_categoria:           oTema.id_categoria,
      id_fb_resp_analista:    oTema.analista,
      id_fb_resp_supervisor:  oTema.supervisor,
      id_fb_resp_coordinador: oTema.coordinador
    };
    this.store.dispatch(cargaAcuerdo({ oAcuerdo }));
  }

  fnCargaTema (oTema: any) {
    console.log(oTema);
    let oAcuerdo = {  
      //id_acuerdo:             string;
      //id_forma_envio:         string;
      //id_tipo_forma:          number;
      fechaAcuerdo:           oTema.fechaAcuerdo,
      id_tema:                oTema.id,
      id_categorizacion:      oTema.categorizacion,
      id_tipo_tema:           oTema.tipoTema,
      id_edo_tema:            oTema.edoTema,
      indice:                 oTema.indiceTema,
      nombreTema:             oTema.nombreTema,
      descripcionTema:        oTema.descripcionTema,
      descripcionTema_html:   oTema.descripcionTema_html,
      banEsConfidencial:      oTema.esConfidencial,
      banEsAprobado:          oTema.esAprobado,
      banEsImpreso:           oTema.esImpreso,
      id_fb_resp_analista:    oTema.respAnalista,
      id_fb_resp_supervisor:  oTema.respSupervisor,
      id_fb_resp_coordinador: oTema.respCoordinador,
      id_categoria:           oTema.id_categoria
      //numeroEntradasTema:     number;
      //id_tipo_despacho:       number;
      //id_empresa:             string;
      //nombre_empresa:         string;
      //isloading:              boolean;
    };

    this.store.dispatch(cargaAcuerdo({ oAcuerdo }));
  }

  fnValidaForm () {
    this.formAcuerdo.statusChanges.subscribe((status:any) => {
      if(status == 'VALID') {
        this.sendToFather.next({formAcuerdo: status}); 
      }
    })
  }

  fnTemaConfidencial () {
    let confidencial = false;
    let data = this.formAcuerdo.value;

    if(this.tipoFormAlta == '' && 
      data.tema != "" && 
      data.id_categorizacion != '' &&
      this.oUsuario.lectura.includes(data.id_categorizacion) == false) {
      confidencial = true;
    }

    return confidencial;
  }

  fnResetForm (acuerdo = false) {
    if(acuerdo) {
      this.formAcuerdo.get('acuerdo')?.setValue('', {emitEvent: false});
    }

    this.formAcuerdo.get('tema')?.setValue('', {emitEvent: false});
    this.formAcuerdo.get('descripcion_tema')?.setValue('', {emitEvent: false});
    this.formAcuerdo.get('tipo_tema')?.setValue('', {emitEvent: false});
    this.formAcuerdo.get('confidencial')?.setValue(false, {emitEvent: false});
    this.formAcuerdo.get('id_categorizacion')?.setValue('', {emitEvent: false});
    this.formAcuerdo.get('id_categoria')?.setValue('', {emitEvent: false});
    this.formAcuerdo.get('analista')?.setValue('', {emitEvent: false});
    this.formAcuerdo.get('supervisor')?.setValue('', {emitEvent: false});
    this.formAcuerdo.get('coordinador')?.setValue('', {emitEvent: false});
  }

  fnValidaResponsablesTema (acuerdo:any) {
    if(acuerdo.respAnalista && acuerdo.respSupervisor && acuerdo.respCoordinador) {
      if(this.catUsuarios.filter((item: any) => item.activo && item.mostrar && item.rol == 1 && item.id == acuerdo.respAnalista).length == 0) {
        acuerdo.respAnalista = "";
      }
      if(this.catUsuarios.filter((item: any) => item.activo && item.mostrar && item.rol == 2 && item.id == acuerdo.respSupervisor).length == 0) {
        acuerdo.respSupervisor = "";
      }
      if(this.catUsuarios.filter((item: any) => item.activo && item.mostrar && item.rol == 3 && item.id == acuerdo.respCoordinador).length == 0) {
        acuerdo.respCoordinador = "";
      }
    }

    if(acuerdo.id_fb_resp_analista && acuerdo.id_fb_resp_supervisor && acuerdo.id_fb_resp_coordinador) {
      if(this.catUsuarios.filter((item: any) => item.activo && item.mostrar && item.rol == 1 && item.id == acuerdo.id_fb_resp_analista).length == 0) {
        acuerdo.id_fb_resp_analista = "";
      }
      if(this.catUsuarios.filter((item: any) => item.activo && item.mostrar && item.rol == 2 && item.id == acuerdo.id_fb_resp_supervisor).length == 0) {
        acuerdo.id_fb_resp_supervisor = "";
      }
      if(this.catUsuarios.filter((item: any) => item.activo && item.mostrar && item.rol == 3 && item.id == acuerdo.id_fb_resp_coordinador).length == 0) {
        acuerdo.id_fb_resp_coordinador = "";
      }
    }

    return acuerdo;
  }

  obtenerCategoria(idCategoria: string, tipo: string) {
    const categoria = this.catCategoria.filter((item:any) => item.id == idCategoria);
    if(categoria.length == 1 && tipo == 'color')
      return categoria[0].id;
    
    if(categoria.length == 1 && tipo == 'descripcion')
      return categoria[0].descripcion;
  }

  fnResetAcuerdo() {
    let oAcuerdo = {
      id_tema:                '',
      descripcionTema:        '',
      descripcionTema_html:   '',
      id_tipo_tema:           '',
      banEsConfidencial:      '',
      id_categorizacion:      '',
      id_categoria:           '',
      id_fb_resp_analista:    '',
      id_fb_resp_supervisor:  '',
      id_fb_resp_coordinador: ''
    };
    this.store.dispatch(cargaAcuerdo({ oAcuerdo }));
  }

  validateAnalista (control: FormControl){
    if(control.value === '') {
      return { required:true };
    }
    if(control.value && this.catUsuarios.filter((item:any) => item.id == control.value && item.activo && item.mostrar && item.rol === 1).length == 0){
      return { required:true };
    }
    return null;
  }

  validateSupervisor (control: FormControl){
    if(control.value === '') {
      return { required:true };
    }
    if(control.value && this.catUsuarios.filter((item:any) => item.id == control.value && item.activo && item.mostrar && item.rol === 2).length == 0){
      return { required:true };
    }
    return null;
  }

  validateCoordinador (control: FormControl){
    if(control.value === '') {
      return { required:true };
    }
    if(control.value && this.catUsuarios.filter((item:any) => item.id == control.value && item.activo && item.mostrar && item.rol === 3).length == 0){
      return { required:true };
    }
    return null;
  }

  ngOnDestroy(): void {
    this.editor.destroy();
    this.editor_alta.destroy();
    this.subscriptions.unsubscribe();
    //this.fnResetAcuerdo();
  }
}